import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';

interface LocationMapProps {
  latitude: number;
  longitude: number;
  title?: string;
  height?: string;
}

const containerStyle = {
  width: '100%',
  borderRadius: '8px'
};

const LocationMap: React.FC<LocationMapProps> = ({
  latitude,
  longitude,
  title,
  height = '300px'
}) => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey,
  });

  const position = { lat: latitude, lng: longitude };

  if (loadError) {
    return (
      <div style={{ padding: '1rem', textAlign: 'center', color: '#666' }}>
        Error loading map
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div style={{ padding: '1rem', textAlign: 'center', color: '#666' }}>
        Loading map...
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerStyle={{ ...containerStyle, height }}
      center={position}
      zoom={15}
      options={{
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
      }}
    >
      <Marker
        position={position}
        title={title}
      />
    </GoogleMap>
  );
};

export default LocationMap;
